import classes from "./SuccessPreregistry.module.scss";
import { useTranslation } from "react-i18next";

const SuccessPreRegistry = () => {
  const { t } = useTranslation();

  return (
    <div className={classes["page"]}>
      <div className={"container"}>
        <div className={classes["wrapper"]}>
          <svg
            className={classes["icon"]}
            xmlns="http://www.w3.org/2000/svg"
            width="61"
            height="61"
            viewBox="0 0 61 61"
            fill="none"
          >
            <g clip-path="url(#clip0_29458_19025)">
              <path
                d="M30.4999 5.0835C44.5375 5.0835 55.9166 16.4625 55.9166 30.5002C55.9166 44.5378 44.5375 55.9168 30.4999 55.9168C16.4623 55.9168 5.08325 44.5378 5.08325 30.5002C5.08325 16.4625 16.4623 5.0835 30.4999 5.0835ZM30.4999 10.1668C25.1072 10.1668 19.9353 12.3091 16.1221 16.1223C12.3088 19.9356 10.1666 25.1074 10.1666 30.5002C10.1666 35.8929 12.3088 41.0648 16.1221 44.878C19.9353 48.6912 25.1072 50.8335 30.4999 50.8335C35.8927 50.8335 41.0645 48.6912 44.8778 44.878C48.691 41.0648 50.8333 35.8929 50.8333 30.5002C50.8333 25.1074 48.691 19.9356 44.8778 16.1223C41.0645 12.3091 35.8927 10.1668 30.4999 10.1668ZM39.4847 21.3019C39.941 20.8412 40.5562 20.5723 41.2043 20.5503C41.8523 20.5284 42.4843 20.7549 42.9708 21.1836C43.4573 21.6123 43.7616 22.2107 43.8213 22.8564C43.881 23.5021 43.6917 24.1462 43.2921 24.6569L43.0812 24.8958L28.8834 39.0961C28.3988 39.5806 27.7532 39.8703 27.0691 39.9101C26.385 39.9499 25.7101 39.7371 25.1726 39.3121L24.9286 39.0961L17.9187 32.0862C17.458 31.6298 17.1891 31.0147 17.1671 30.3666C17.1452 29.7185 17.3717 29.0866 17.8004 28.6001C18.2291 28.1136 18.8275 27.8093 19.4732 27.7496C20.1189 27.6898 20.763 27.8791 21.2737 28.2787L21.5126 28.4922L26.906 33.8831L39.4873 21.3019H39.4847Z"
                fill="#FF8C42"
              />
            </g>
            <defs>
              <clipPath id="clip0_29458_19025">
                <rect width="61" height="61" fill="white" />
              </clipPath>
            </defs>
          </svg>

          <h1>{t("ThankYouForPreRegistering")}</h1>
          <p>{t("YouAreOnTheList")}</p>
          <p>{t("WeArePuttingTheFinalTouchesOnClubPass")}</p>

          <h3>{t("WithClubPassYouWillBeAbleTo")}</h3>
          <ul>
            <li>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0ZM10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2ZM13.535 6.381C13.7145 6.19975 13.9566 6.09397 14.2115 6.08532C14.4665 6.07667 14.7152 6.1658 14.9066 6.33447C15.098 6.50313 15.2177 6.73858 15.2412 6.99262C15.2647 7.24666 15.1902 7.50008 15.033 7.701L14.95 7.795L9.364 13.382C9.17335 13.5726 8.91932 13.6866 8.65017 13.7023C8.38102 13.7179 8.11549 13.6342 7.904 13.467L7.808 13.382L5.05 10.624C4.86875 10.4445 4.76297 10.2024 4.75432 9.94745C4.74567 9.69248 4.8348 9.44383 5.00347 9.25242C5.17213 9.06101 5.40758 8.9413 5.66162 8.9178C5.91566 8.89429 6.16908 8.96878 6.37 9.126L6.464 9.21L8.586 11.331L13.536 6.381H13.535Z"
                  fill="#FF8C42"
                />
              </svg>
              {t("BookGymSessionsFitnessClasses")}
            </li>
            <li>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0ZM10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2ZM13.535 6.381C13.7145 6.19975 13.9566 6.09397 14.2115 6.08532C14.4665 6.07667 14.7152 6.1658 14.9066 6.33447C15.098 6.50313 15.2177 6.73858 15.2412 6.99262C15.2647 7.24666 15.1902 7.50008 15.033 7.701L14.95 7.795L9.364 13.382C9.17335 13.5726 8.91932 13.6866 8.65017 13.7023C8.38102 13.7179 8.11549 13.6342 7.904 13.467L7.808 13.382L5.05 10.624C4.86875 10.4445 4.76297 10.2024 4.75432 9.94745C4.74567 9.69248 4.8348 9.44383 5.00347 9.25242C5.17213 9.06101 5.40758 8.9413 5.66162 8.9178C5.91566 8.89429 6.16908 8.96878 6.37 9.126L6.464 9.21L8.586 11.331L13.536 6.381H13.535Z"
                  fill="#FF8C42"
                />
              </svg>
              {t("DiscoverNewStudiosAndExperiences")}
            </li>
            <li>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0ZM10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2ZM13.535 6.381C13.7145 6.19975 13.9566 6.09397 14.2115 6.08532C14.4665 6.07667 14.7152 6.1658 14.9066 6.33447C15.098 6.50313 15.2177 6.73858 15.2412 6.99262C15.2647 7.24666 15.1902 7.50008 15.033 7.701L14.95 7.795L9.364 13.382C9.17335 13.5726 8.91932 13.6866 8.65017 13.7023C8.38102 13.7179 8.11549 13.6342 7.904 13.467L7.808 13.382L5.05 10.624C4.86875 10.4445 4.76297 10.2024 4.75432 9.94745C4.74567 9.69248 4.8348 9.44383 5.00347 9.25242C5.17213 9.06101 5.40758 8.9413 5.66162 8.9178C5.91566 8.89429 6.16908 8.96878 6.37 9.126L6.464 9.21L8.586 11.331L13.536 6.381H13.535Z"
                  fill="#FF8C42"
                />
              </svg>
              {t("AccessExclusiveLaunchOffersFor")}
            </li>
          </ul>

          <span>{t("KeepAnEyeOnYourInboxYourEarly")}</span>
        </div>
      </div>
    </div>
  );
};

export default SuccessPreRegistry;
